const WORKFLOW_EXEC_FAILED = { message: "Workflow execution failed", severity: "error", status: 500, service: "workflow" };
const WORKFLOW_TIMEOUT = { message: "Workflow execution timed out", severity: "error", status: 504, service: "workflow" };
// A caller asking for one label past the cap. `info`, not `error`: the request was refused
// and nothing is wrong with the service, so it must not feed the 5xx-rate page.
const WORKFLOW_LABEL_LIMIT = { message: "Too many labels for one workflow", severity: "info", status: 400, service: "workflow" };
// The org may read workflow code but not save it. `info`, not `error`: the
// request was refused by configuration and nothing is wrong with the service,
// so it must not feed the 5xx-rate page. 403 rather than 401 — the caller is
// authenticated and the answer will not change by re-authenticating.
const WORKFLOW_CODE_READ_ONLY = { message: "This organisation can read workflow code but not change it", severity: "info", status: 403, service: "workflow" };
/** Workflow service codes. Canonical `WF-*`; legacy flat names kept as aliases. */
export const WORKFLOW_ERRORS = {
    "WF-EXEC-FAILED": WORKFLOW_EXEC_FAILED,
    "WF-TIMEOUT": WORKFLOW_TIMEOUT,
    "WF-LABEL-LIMIT": WORKFLOW_LABEL_LIMIT,
    "WF-CODE-READONLY": WORKFLOW_CODE_READ_ONLY,
    WORKFLOW_EXEC_FAILED,
    WORKFLOW_TIMEOUT,
    WORKFLOW_LABEL_LIMIT,
    WORKFLOW_CODE_READ_ONLY,
};
//# sourceMappingURL=workflow.js.map